import { Company, TaxRegimeType } from '@/types'
import { formatCurrency } from './currency'

const SIMPLE_NATIONAL_TAX_REGIMES: TaxRegimeType[] = [
  'simple_national',
  'simple_national_excess',
]

const TAXES_TEXT_REGEX = /\s*Trib aprox:[\s\S]*?Fonte Lei nº 12\.741\/12\.\s*$/

export const isSimpleNationalCompany = (company?: Company | null) =>
  !!company?.tax_regime &&
  SIMPLE_NATIONAL_TAX_REGIMES.includes(company.tax_regime.tax_regime)

export const getTaxesText = (value: number | string): string => {
  const numericValue = Number(value)
  const federalTax = numericValue * 0.04
  const municipalTax = numericValue * 0.02
  const noDecimals = { minimumFractionDigits: 0, maximumFractionDigits: 0 }

  return `Trib aprox: ${formatCurrency(federalTax, noDecimals).replace(/^R\$\s+/, 'R$')} (4% - Federal) e ${formatCurrency(municipalTax, noDecimals).replace(/^R\$\s+/, 'R$')} (2% - Municipal) Fonte Lei nº 12.741/12.`
}

export const stripTaxesText = (description: string): string =>
  description.replace(TAXES_TEXT_REGEX, '')

export const applyTaxesText = (
  description: string,
  value: number | string,
): string => {
  const baseDescription = stripTaxesText(description)
  const numericValue = Number(value)

  if (!numericValue || numericValue <= 0) return baseDescription

  return `${baseDescription}\n\n${getTaxesText(numericValue)}`
}
